"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CarouselControls;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const borderColor = _intents.default.ux.boxHighContrast.backgroundColor;
const borderColorDisabled = _intents.default.ux.boxLowContrast.borderColor;
const ControlsWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ControlsWrapper",
  class: "pl-c1b44kk",
  vars: {
    "c1b44kk-2": [({
      showMobileControls
    }) => showMobileControls ? 'flex' : 'none']
  }
});
const ButtonShared = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "ButtonShared",
  class: "pl-bowwot2",
  vars: {
    "bowwot2-0": [({
      disabled
    }) => disabled ? borderColorDisabled : borderColor],
    "bowwot2-1": [({
      isSmallControls
    }) => isSmallControls ? '.5rem' : '1rem'],
    "bowwot2-2": [({
      isSmallControls
    }) => isSmallControls ? 'scale(0.8)' : 'scale(1.2)']
  }
});
const PrevButton = /*#__PURE__*/(0, _react2.styled)(ButtonShared)({
  name: "PrevButton",
  class: "pl-pbfvqxu"
});
const NextButton = /*#__PURE__*/(0, _react2.styled)(ButtonShared)({
  name: "NextButton",
  class: "pl-n3fadkt"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconWrapper",
  class: "pl-iia4nxp"
});
function CarouselControls({
  disablePrev,
  disableNext,
  isSmallControls,
  nextButtonAriaLabel = 'Next',
  nextCallback,
  prevButtonAriaLabel = 'Previous',
  prevCallback,
  showMobileControls
}) {
  return /*#__PURE__*/_react.default.createElement(ControlsWrapper, {
    showMobileControls: showMobileControls
  }, /*#__PURE__*/_react.default.createElement(PrevButton, {
    "aria-label": prevButtonAriaLabel,
    disabled: disablePrev,
    isSmallControls: isSmallControls,
    onClick: prevCallback
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))), /*#__PURE__*/_react.default.createElement(NextButton, {
    "aria-label": nextButtonAriaLabel,
    disabled: disableNext,
    isSmallControls: isSmallControls,
    onClick: nextCallback
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))));
}
CarouselControls.propTypes = {
  disableNext: _propTypes.default.bool,
  disablePrev: _propTypes.default.bool,
  isSmallControls: _propTypes.default.bool,
  prevButtonAriaLabel: _propTypes.default.string,
  prevCallback: _propTypes.default.func,
  nextButtonAriaLabel: _propTypes.default.string,
  nextCallback: _propTypes.default.func,
  showMobileControls: _propTypes.default.bool
};